import axiosClient from "../axios-client";

export interface NonRevAirline {
    nonRevAirlineId: number;
    nonRevAirlineName: string;
}

export interface NonRevConfig {
    airlineId: number;
    airlineName: string;
    nonRevAirlineCount: number;
    nonRevAirlines: NonRevAirline[];
}

export interface AddNonRevConfigPayload {
    airlineId: number;
    nonRevAirlineIds: number[];
}

export interface UpdateNonRevConfigPayload {
    airlineId: number;
    nonRevAirlines: number[];
}

export const getNonRevConfigs = async (page = 1, pageSize = 10, searchAirlineName = ""): Promise<{ items: NonRevConfig[], totalCount: number, page: number, pageSize: number }> => {
    const response = await axiosClient.get("/admin/AdminNonRevConfig/GetNonRevAirlinesConfigs", {
        params: {
            page,
            pageSize,
            searchAirlineName,
        },
    });
    // axios interceptor already returns response.data, so response is the actual API data
    return response as any;
};

export const addNonRevConfig = async (payload: AddNonRevConfigPayload) => {
    const response = await axiosClient.post("/admin/AdminNonRevConfig/AddNonRevconfig", payload);
    return response;
};

export const updateNonRevConfig = async (payload: UpdateNonRevConfigPayload) => {
    const response = await axiosClient.post("/admin/AdminNonRevConfig/UpdateNonRevConfig", payload);
    return response;
};

export const deleteNonRevConfig = async (airlineId: number) => {
    const response = await axiosClient.delete(`/admin/AdminNonRevConfig/DeleteNonRev?airlineId=${airlineId}`);
    return response;
};

export const getNonRevFlightList = async (airlineId?: number) => {
    const response = await axiosClient.get("/admin/AdminNonRevConfig/NonRevFlightListofAirlines", {
        params: {
            AirlineId: airlineId,
        },
    });
    return response;
};
